/**
 * SavesImmediatelyCaption — marks a list or card whose rows save the moment
 * they are changed (add, edit, delete, toggle), so nobody looks for the
 * page's Save changes button on it. Shown as the settings page's "Saves
 * automatically" chip; settings that wait for Save changes carry none.
 */
import React, { useContext } from 'react';
import { InstantSaveChip, INSTANT_SAVE_TEXT } from './primitives/InstantSaveChip';
import { InstantCaptionShownContext } from './instantCaption';

export const SAVES_IMMEDIATELY_TEXT = INSTANT_SAVE_TEXT;

export interface SavesImmediatelyCaptionProps {
  testId?: string;
  style?: React.CSSProperties;
}

export const SavesImmediatelyCaption: React.FC<SavesImmediatelyCaptionProps> = ({ testId = 'saves-immediately-caption', style }) => {
  // The section's own caption is already up (an instant-save section): say it once.
  const shownAbove = useContext(InstantCaptionShownContext);
  if (shownAbove) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-start', margin: '2px 0 0', ...style }}>
      <InstantSaveChip testId={testId} />
    </div>
  );
};

export default SavesImmediatelyCaption;
